import React, { FC } from "react";
import { IFAQ } from "../../../@core/interfaces/IFAQ";

export const FAQItem: FC<{
  faq: IFAQ;
  onEdit: (faq: IFAQ) => void;
  onDelete: (id: string) => void;
}> = ({ faq, onEdit, onDelete }) => {
  return (
    <div className="p-4 mb-4 border border-neutral-200 dark:border-neutral-700 rounded-lg">
      <div className="flex justify-between items-start">
        <div className="flex-grow">
          <h3 className="text-lg font-medium">{faq.question}</h3>
          <p className="mt-2 text-neutral-500 dark:text-neutral-400">{faq.answer}</p>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={() => onEdit(faq)}
            className="text-primary-600 hover:text-primary-500"
          >
            Edit
          </button>
          <button
            onClick={() => onDelete(faq.id || "")}
            className="text-red-600 hover:text-red-500"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};
